import type { AdminAgentChangedModelRef, IAdminStore } from '@mcn-platform/models';
import { isOrganizationScoped } from '@mcn-platform/models';

/**
 * Reloads entities in the MST store after the admin agent (or GraphQL via agent) mutates data.
 * Uses `load(model, key, -1)` to bypass cache age, matching other refresh flows.
 */
export async function applyAdminAgentChangedModelRefs(
  store: IAdminStore,
  refs: AdminAgentChangedModelRef[],
  currentOrganizationId: string | undefined,
): Promise<void> {
  if (!refs.length) return;

  for (const ref of refs) {
    const model = ref.model?.trim();
    if (!model) continue;
    const id = ref.id?.trim();
    if (!id) continue;

    const org = ref.organizationID?.trim() || currentOrganizationId;
    let key: string;
    if (isOrganizationScoped(model)) {
      if (!org) {
        console.warn('applyAdminAgentChangedModelRefs: skipping org-scoped model without organizationID', ref);
        continue;
      }
      key = `${org}~${id}`;
    } else {
      key = id;
    }

    try {
      await store.load(model, key, -1);
    } catch (e) {
      console.warn('applyAdminAgentChangedModelRefs: load failed', ref, e);
    }
  }
}
